import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
var Tipo_recepcionComponent = /** @class */ (function () {
    function Tipo_recepcionComponent(fb) {
        this.fb = fb;
        this.rows = [];
        this.tipos = ['RECEPCION DEFINITIVA PARCIAL', 'RECEPCION DEFINITIVA TOTAL'];
        this.form = new FormGroup({
            option: new FormControl('', Validators.required)
        });
        if (!JSON.parse(localStorage.getItem("tipo_recepcion"))) {
            localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_recepcion"));
            this.form.controls['option'].setValue(this.rows[0] ? this.rows[0].option : false);
        }
    }
    Tipo_recepcionComponent.prototype.add_tipo_recepcion = function (event) {
        var checkTipoRecepcion = event.value;
        localStorage.setItem("tipo_recepcion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_recepcion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            option: checkTipoRecepcion
        });
        localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
        console.log(localStorage.getItem("tipo_recepcion"));
    };
    Tipo_recepcionComponent.prototype.delete_tipo_recepcion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_recepcion", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_recepcionComponent;
}());
export { Tipo_recepcionComponent };
